<template>
  <v-textarea
    :value="value"
    auto-grow
    counter="1000"
    label="Observação"
    maxlength="1000"
    outlined
    :rows="rows"
    @input="$emit('input', $event)"
  />
</template>

<script>
  export default {
    name: 'ObservacaoTarefa',

    props: {
      value: {
        type: String,
        default: ''
      },
      rows: {
        type: Number,
        default: 3
      }
    }
  };
</script>
